<template>
  <main class="main" role="main">
    <div class="main__inner"><!-- 배경: bg-->
      <div class="main__con">
        <div class="main__page">
          <div class="p16">
            <form class="search">
              <input type="search" placeholder="검색어를 입력하세요." title="" v-model="searchText" v-on:keydown.enter="$event.preventDefault()">
              <button type="reset" v-show="searchText.length > 0" @click="fnDeleteSearchText"></button><!--★ 텍스트가 입력되면 보여지고, 버튼을 클릭하면 사라지게 작업해주세요 구글 검색창 참고해주세요! ★-->
            </form>
          </div>
          <div class="notice__page">
            <ul class="notice__page__ul">
              <li class="notice__page__li type_03" v-for="(item, index) in tempFaqList" :key="index" @click="fnView(item)">
                <div class="txt_box">
                  <div class="txt">
                    <p>{{ item.boardTitle }}</p>
                  </div>
                  <button :class="item.isOpen ? 'dropup' : 'dropdown'"></button>
                </div>
                <div class="txt_inner width100 editor" v-show="item.isOpen" v-html="item.boardDescription">

                </div>
              </li>
            </ul>
            <infinite-loading @infinite="getFaqList">
              <div slot="spinner"></div>
              <div slot="no-more"></div>
              <div slot="no-results">
                <div class="complete">
                  <img src="@/assets/static/images/img_notice.svg" alt="" class="complete__img">
                  <span class="complete__txt__type02">내역이 없습니다.</span>
                </div>
              </div>
            </infinite-loading>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import InfiniteLoading from 'vue-infinite-loading'
export default {
  components: {InfiniteLoading},
  data: function () {
    return {
      params: {
        page: 1,
        limit: 99999999,
        boardType: 2
      },
      searchText: '',
      pageInfo: {},
      faqList: []
    }
  },
  computed: {
    tempFaqList: function() {
      const searchList = []
      if (this.searchText.trim().length <= 0) {
        return this.faqList
      } else {
        this.faqList.filter(item => {
          if (item.boardTitle.indexOf(this.searchText) >= 0) {
            searchList.push(item)
          }
        })
        return searchList
      }
    }
  },
  created: function () {
  },
  methods: {
    getFaqList: async function ($state) {
      const res = await this.$MypageSvc.getBoardList(this.params)
      const code = res.code
      const message = res.message
      const entity = res.entity

      console.log('code: %d\nmessage: %s\nentity: %o\nstringify: \n%s', code, message, entity, JSON.stringify(entity))

      if (code === 1) {
        const faqList = entity.list
          faqList.forEach(item => {
          item.isOpen = false
        })
        this.faqList = this.faqList.concat(faqList)
        this.pageInfo = entity.pageInfo
        this.params.page = this.params.page + 1

        if (this.pageInfo.page >= this.pageInfo.endPage) {
          $state.complete()
        }
        if (this.pageInfo.totalRow > 0) {
          $state.loaded()
        }
      } else {
        $state.complete()
        this.$Util.modalAlert({message: message})
      }
    },
    fnView: function (item) {
      item.isOpen = !item.isOpen
    },
    fnDeleteSearchText: function () {
      this.searchText = ''
    }
  }
}
</script>
